import styled from "styled-components";  

export const Item = styled.div`
  margin-bottom: 0px;
`;

export const Question = styled.h2`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0;
  transition: color 0.3s ease;

  &:hover {
    color: #4a4a4a;
  }
`;

export const Arrow = styled.span`
  display: inline-block;
  margin-left: 10px;
  font-size: 1rem;
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
`;

export const Answer = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? "1000px" : "0")};
  overflow: hidden;
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  transition: max-height 0.4s ease, opacity 0.3s ease;
  margin-top: ${({ isOpen }) => (isOpen ? "10px" : "0")};
  line-height: 1.6;
  color: #444;
  p {
    font-size: 1.2rem;
  }
`;